import { type Token } from "src/client/models/Token";

const SESSION = "SESSION";

class AuthService {
  handleAuthentication = (session: Token): void => {
    if (session === null) return;
    this.setSession(session);
  };

  logout = (): void => {
    this.setSession(null);
    window.location.href = window.origin;
  };

  setSession = (session: Token | null): void => {
    this._setCookie(session);
    if (session !== null) {
      localStorage.setItem(SESSION, JSON.stringify(session));
    } else {
      localStorage.removeItem(SESSION);
    }
  };

  getSession = (): Token | null => {
    const session = localStorage.getItem(SESSION);
    if (session !== null) return JSON.parse(session);
    return null;
  };

  _setCookie = (session: Token | null) => {
    const date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000);

    if (!session) {
      document.cookie = "";
    } else {
      document.cookie = `ws_auth_token=${
        session.accessToken
      }; expires=${date.toUTCString()}; path=/`;
    }
  };
}

const authService = new AuthService();

export default authService;
